import series from '@/application/lib/series'

export default {
    data() {
        return {
            view: 'expenseForm',
            app: 'expenses',
            loading: false,
            fields: {
                bill_date: this.$moment().format('YYYY-MM-DD'),
                invoice_date: this.$moment().format('YYYY-MM-DD'),
                iva: 0,
                payment_method: 0,
                provider: null,
                serie: '',
                serie_r: null,
                status: 0,
                subtotal: '',
                total: '',
                concepts: [],
            },
            provider_data: {
                name: '',
                address: '',
                cp: '',
                state: '',
                country: '',
                location: '',
            },
        }
    },
    computed: {
        id() {
            return parseInt(this.$route.params.id, 10) || 0
        },
        config() {
            return this.$gestios.$cache.config
        },
    },
    methods: {
        // Load events
        events(enable = true) {
            if (enable) {
                this.$hub.$on('listExpense', () => {
                    this.$router.push({ name: 'expenses' })
                })
            } else {
                this.$hub.$off('listExpense')
            }
        },
        // Load config
        async loadConfig() {
            return await this.$gestios.config.list(['name', 'address', 'address2', 'CIF', 'mail', 'phone', 'logo'])
        },
        // Load expense
        async load() {
            if (this.id > 0) {
                this.loading = true

                let expense = await this.$gestios.items('expenses').get(this.id)

                if (expense.ok) {
                    expense = expense.data

                    const provider = await this.$gestios.items('providers').get(expense.provider._EntityId)

                    if (provider.ok) {
                        this.$nextTick(() => {
                            this.fields.provider = {
                                key: expense.provider._EntityId.toString(),
                                label: expense.provider.name,
                                data: provider.data,
                            }
                        })
                    } else {
                        this.$gestios.$message.error('No se encontro el proveedor.')
                    }

                    this.fields.bill_date = expense.bill_date
                    this.fields.invoice_date = expense.invoice_date
                    this.fields.surcharge = expense.surcharge
                    this.fields.iva = expense.iva
                    this.fields.payment_method = expense.payment_method
                    this.fields.serie = expense.serie
                    this.fields.serie_r = expense.serie_r
                    this.fields.status = expense.status
                    this.fields.subtotal = expense.subtotal
                    this.fields.total = expense.total

                    await expense.concepts.map(async (concept) => {
                        const toShow = {
                            ...concept,
                            article: {
                                key: undefined,
                                label: 'Seleccione una opción',
                            },
                            iva: 0,
                            price: concept.price,
                            discount: concept.discount,
                            quantity: concept.quantity,
                            text: concept.text,
                        }
                        // Si el concpeto es relacional, añadimos los datos
                        if (concept.good) {
                            const good = await this.$gestios.items('goods').get(concept.good)

                            if (good.ok) {
                                toShow.article = {
                                    key: concept.good,
                                    label: good.data.name,
                                    data: good.data,
                                }
                                toShow.iva = good.data.iva
                            }
                        }

                        this.fields.concepts.push(toShow)
                    })
                }

                this.loading = false
            } else {
                this.createConcept()
            }
        },
        // Save expense
        async save() {
            try {
                this.loading = true

                const params = {
                    // GENERAL
                    subtotal: this.totalCalculations.subtotal,
                    total: this.totalCalculations.total,
                    iva: this.totalCalculations.iva.value,
                    bill_date: this.fields.bill_date,
                    invoice_date: this.fields.invoice_date,
                    status: this.fields.status,
                    payment_method: this.fields.payment_method,
                    serie: this.fields.serie,
                    serie_r: this.fields.serie_r._EntityId,
                    irfp: null,

                    // CLIENT
                    provider: this.fields.provider.key,

                    concepts: [],
                }

                Object.keys(this.fields.concepts).forEach((key) => {
                    const concept = this.fields.concepts[key]

                    params.concepts.push({
                        discount: concept.discount,
                        good: concept.good,
                        price: concept.price,
                        quantity: concept.quantity,
                        text: concept.text,
                    })
                })

                params.concepts = JSON.stringify(params.concepts)

                let data
                if (this.id > 0) {
                    data = await this.$gestios.items('expenses').edit({ id: this.id, params })
                } else {
                    data = await this.$gestios.items('expenses').add({ params, view: this.view })
                }

                if (data.ok) {
                    if (!this.id && this.nextSerie && this.nextSerie === params.serie) {
                        await series.editSerialValue(this.fields.serie_r._EntityId)
                    }
                    this.$router.push({ name: 'expenses' })
                }
            } catch (err) {
                console.error(err)
            } finally {
                this.loading = false
            }
        },
        // Reset expense form
        reset() {
            this.fields.concepts = [
                {
                    article: null,
                    discount: 0,
                    expiration_date: this.$moment(),
                    lot: null,
                    name: '',
                    price: 0,
                    quantity: 1,
                    iva: 0,
                },
            ]

            this.resetProvider()
        },
        // Reset provider
        resetProvider() {
            this.fields.provider = null

            this.provider_data.address = ''
            this.provider_data.cp = ''
            this.provider_data.location = ''
            this.provider_data.state = ''
            this.provider_data.country = ''
        },
    },
}
